// extracted by mini-css-extract-plugin
module.exports = {"BannerWrapper":"style_BannerWrapper__2CoX7","HeaderText":"style_HeaderText__nDvJT","Scroll":"style_Scroll__3vH0E","BannerArticleWrapper":"style_BannerArticleWrapper__2rF4L"};